<template>
  <div class="admin-page bg-neutral-50 min-h-screen pt-6 pb-16">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <!-- 页面标题 -->
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-neutral-900">管理后台</h1>
        <p class="text-neutral-500 text-sm mt-1">平台数据管理与监控中心</p>
      </div>

      <div class="flex flex-col lg:flex-row gap-6">
        <!-- 左侧菜单 -->
        <AdminSidebar
          :menus="visibleMenus"
          :current-menu="currentMenu"
          @select="selectMenu"
        />

        <!-- 右侧内容 -->
        <div class="flex-1 min-w-0">
          <!-- 数据中心 -->
          <DashboardPanel v-if="currentMenu === 'dashboard'" :stats="stats" />

          <!-- 数据大盘 -->
          <BigDataPanel v-else-if="currentMenu === 'bigdata'" />

          <!-- 上传管理 -->
          <UploadManager
            v-else-if="currentMenu === 'uploads'"
            :list="uploadList"
            :total="uploadTotal"
            :page="uploadPage"
            :page-size="uploadPageSize"
            :loading="uploadLoading"
            :current-status="uploadStatus"
            :category-list="categoryList"
            @approve="approveUpload"
            @reject="rejectUpload"
            @delete="deleteUpload"
            @view-detail="openToolDetail"
            @download="downloadAttachment"
            @refresh="getUploads"
            @page-change="handleUploadPageChange"
            @status-change="changeUploadStatus"
          />

          <!-- 需求管理 -->
          <RequestManager v-else-if="currentMenu === 'requests'" />

          <!-- 案例审核 -->
          <CaseManager v-else-if="currentMenu === 'cases'" />

          <!-- 工具榜 -->
          <!-- <ToolRanking v-else-if="currentMenu === 'ranking'" /> -->

          <!-- 创值榜 -->
          <PointBoard
            v-else-if="currentMenu === 'points'"
            :list="userList"
            :total="userTotal"
            @page-change="handleUserPageChange"
            @search="handleUserSearch"
          />

          <!-- 常用链接 -->
          <LinkManager v-else-if="currentMenu === 'links'" />

          <!-- 首页轮播 -->
          <BannerManager v-else-if="currentMenu === 'banners'" />

          <!-- 场景分类 -->
          <CategoryManager v-else-if="currentMenu === 'categories'" />

          <!-- 需求分类 -->
          <DemandCategoryManager v-else-if="currentMenu === 'demandcats'" />

          <!-- 学科知识体系 -->
          <EduTreeManager v-else-if="currentMenu === 'edutree'" />

          <!-- 网页YI起建 -->
          <WebInfoManager v-else-if="currentMenu === 'webinfo'" />

          <!-- 首页板块设计（Web 端 + 小程序端同步） -->
          <HomeSectionManager v-else-if="currentMenu === 'homedesign'" />

          <!-- 上传大小设置（Web 端 + 小程序端同步） -->
          <UploadLimitManager v-else-if="currentMenu === 'uploadlimit'" />

          <!-- 智能体管理（扣子 / workbuddy 等平台接入） -->
          <AgentManager v-else-if="currentMenu === 'agent'" />

          <!-- 用户权限管理 -->
          <UserPermManager v-else-if="currentMenu === 'admin'" :my-perms="myPerms" />

          <!-- 用户管理 -->
          <UserManager v-else-if="currentMenu === 'users'" />

          <!-- 操作日志 -->
          <OperationLog v-else-if="currentMenu === 'logs'" />

          <!-- 申请审核 -->
          <ApplyManager v-else-if="currentMenu === 'apply'" />

          <!-- 通知与反馈 -->
          <NoticeManager v-else-if="currentMenu === 'notice'" />

          <!-- 下载权限 -->
          <DownloadSetting v-else-if="currentMenu === 'download'" />

          <!-- 提示词审核 -->
          <PromptManager v-else-if="currentMenu === 'prompts'" />

          <!-- 软件分享（仅管理员可发布） -->
          <SoftwareManager v-else-if="currentMenu === 'software'" />

          <!-- SSO 免登站点 -->
          <SsoManager v-else-if="currentMenu === 'sso'" />

          <!-- 创值规则 -->
          <PointRuleManager v-else-if="currentMenu === 'pointrule'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage } from "element-plus";
import { globalState } from "@/state";
import AdminSidebar from "./components/AdminSidebar.vue";
import DashboardPanel from "./components/DashboardPanel.vue";
import BigDataPanel from "./components/BigDataPanel.vue";
import UploadManager from "./components/UploadManager.vue";
import RequestManager from "./components/RequestManager.vue";
import CaseManager from "./components/CaseManager.vue";
import PointBoard from "./components/PointBoard.vue";
import LinkManager from "./components/LinkManager.vue";
import BannerManager from "./components/BannerManager.vue";
import CategoryManager from "./components/CategoryManager.vue";
import DemandCategoryManager from "./components/DemandCategoryManager.vue";
import EduTreeManager from "./components/EduTreeManager.vue";
import WebInfoManager from "./components/WebInfoManager.vue";
import HomeSectionManager from "./components/HomeSectionManager.vue";
import UploadLimitManager from "./components/UploadLimitManager.vue";
import AgentManager from "./components/AgentManager.vue";
import UserPermManager from "./components/UserPermManager.vue";
import UserManager from "./components/UserManager.vue";
import ApplyManager from "./components/ApplyManager.vue";
import NoticeManager from "./components/NoticeManager.vue";
import DownloadSetting from "./components/DownloadSetting.vue";
import PromptManager from "./components/PromptManager.vue";
import SoftwareManager from "./components/SoftwareManager.vue";
import SsoManager from "./components/SsoManager.vue";
import PointRuleManager from "./components/PointRuleManager.vue";
import OperationLog from "./components/OperationLog.vue";
// import ToolRanking from "./components/ToolRanking.vue";

export default {
  name: "AdminPage",
  components: {
    AdminSidebar,
    DashboardPanel,
    BigDataPanel,
    UploadManager,
    RequestManager,
    CaseManager,
    PointBoard,
    LinkManager,
    BannerManager,
    CategoryManager,
    DemandCategoryManager,
    EduTreeManager,
    WebInfoManager,
    HomeSectionManager,
    UploadLimitManager,
    AgentManager,
    UserPermManager,
    UserManager,
    ApplyManager,
    NoticeManager,
    DownloadSetting,
    PromptManager,
    SoftwareManager,
    SsoManager,
    PointRuleManager,
    OperationLog,
  },
  data() {
    return {
      currentMenu: "dashboard",
      myPerms: "",
      menus: [
        { id: "dashboard", name: "数据中心", icon: "fa-bar-chart", perm: "dashboard" },
        { id: "bigdata", name: "数据大盘", icon: "fa-dashboard", perm: "dashboard" },
        { id: "uploads", name: "上传管理", icon: "fa-cloud-upload", perm: "uploads" },
        { id: "uploadlimit", name: "上传设置", icon: "fa-cog", perm: "uploads" },
        { id: "agent", name: "智能体管理", icon: "fa-robot", perm: "agent" },
        { id: "requests", name: "需求管理", icon: "fa-lightbulb-o", perm: "requests" },
        { id: "cases", name: "案例审核", icon: "fa-graduation-cap", perm: "cases" },
        { id: "software", name: "软件分享", icon: "fa-cube", perm: "software" },
        { id: "sso", name: "免登站点", icon: "fa-key", perm: "sso" },
        { id: "points", name: "创值榜", icon: "fa-trophy", perm: "points" },
        { id: "pointrule", name: "创值规则", icon: "fa-sliders", perm: "points" },
        { id: "links", name: "常用链接", icon: "fa-link", perm: "links" },
        { id: "banners", name: "首页轮播", icon: "fa-image", perm: "banner" },
        { id: "categories", name: "场景分类", icon: "fa-th-large", perm: "category" },
        { id: "demandcats", name: "需求分类", icon: "fa-tags", perm: "category" },
        { id: "edutree", name: "学科知识体系", icon: "fa-sitemap", perm: "category" },
        { id: "webinfo", name: "网页YI起建", icon: "fa-window-maximize", perm: "webinfo" },
        { id: "homedesign", name: "首页设计", icon: "fa-th-large", perm: "home" },
        { id: "admin", name: "用户权限", icon: "fa-user-shield", perm: "admin" },
        { id: "users", name: "用户管理", icon: "fa-users", perm: "users" },
        { id: "logs", name: "操作日志", icon: "fa-list-alt", perm: "users" },
        { id: "apply", name: "申请审核", icon: "fa-check-square-o", perm: "apply" },
        { id: "notice", name: "通知与反馈", icon: "fa-bell-o", perm: "apply" },
        { id: "download", name: "下载权限", icon: "fa-download", perm: "points" },
        { id: "prompts", name: "提示词审核", icon: "fa-comment-o", perm: "prompt" },
      ],
      // 统计数据
      stats: {
        toolCount: 0,
        toolSP: 0,
        toolSJ: 0,
        toolJJ: 0,
        toolToday: 0,
        toolWeek: 0,
        toolLY: 0,
        toolLYWeek: 0,
        demandCount: 0,
        demandDJJ: 0,
        demandYJJ: 0,
        demandToday: 0,
        demandToweek: 0,
        demandReplay: 0,
        userCount: 0,
        userToday: 0,
      },
      // 上传管理
      uploadStatus: 0,
      uploadLoading: false,
      uploadList: [],
      uploadTotal: 0,
      uploadPage: 1,
      uploadPageSize: 10,
      categoryList: [],
      // 需求管理 - 已由组件自行处理
      // 创值榜
      userList: [],
      userTotal: 0,
      userPage: 1,
      // 菜单待办徽标数量
      badges: {},
    };
  },
  created() {
    this.init();
  },
  computed: {
    visibleMenus() {
      const list =
        this.myPerms === "*"
          ? this.menus
          : this.menus.filter((m) =>
              (this.myPerms || "").split(",").filter((x) => x).includes(m.perm)
            );
      // 附加待办数量徽标（免点击直接可见）
      return list.map((m) => ({ ...m, badge: this.badges[m.id] || 0 }));
    },
  },
  methods: {
    async init() {
      await this.loadPerms();
      this.loadBadges();
      this.loadData();
    },
    // 加载各模块待办数量（上传/提示词/申请/需求）
    async loadBadges() {
      try {
        const res = await this.$axios({
          url: "datav/badges",
          method: "GET",
        });
        if (res.code === 200 && res.data) {
          this.badges = res.data;
        }
      } catch (e) {
        console.error("获取待办数量失败:", e);
      }
    },
    async loadPerms() {
      try {
        const data = await this.$aesEncrypt({});
        const res = await this.$axios({
          url: "user/admin/perms",
          method: "POST",
          data: { data },
        });
        if (res.code === 200) {
          this.myPerms = res.data.perms || "";
          // 当前菜单无权限时，切换到第一个有权限的菜单
          const ids = this.visibleMenus.map((m) => m.id);
          if (ids.length > 0 && !ids.includes(this.currentMenu)) {
            this.currentMenu = ids[0];
          }
        }
      } catch (e) {
        console.error("获取权限失败:", e);
      }
    },
    selectMenu(menuId) {
      this.currentMenu = menuId;
      this.loadBadges();
      this.loadData();
    },
    async loadData() {
      if (this.currentMenu === "dashboard") {
        await this.getStats();
      } else if (this.currentMenu === "uploads") {
        await this.getCategory();
        await this.getUploads();
      } else if (this.currentMenu === "requests") {
        // 需求管理组件自行处理数据加载
      } else if (this.currentMenu === "ranking") {
        // 工具榜组件自行处理数据加载
      } else if (this.currentMenu === "points") {
        await this.getUsers();
      } else if (this.currentMenu === "links") {
        // 常用链接组件自行处理数据加载
      } else if (this.currentMenu === "webinfo") {
        // 网页YI起建管理暂用静态数据
      }
    },
    async getStats() {
      try {
        const res = await this.$axios({
          url: "datav/console",
          method: "GET",
        });
        if (res.code === 200) {
          this.stats = { ...this.stats, ...res.data };
        }
      } catch (error) {
        console.error("获取统计数据失败:", error);
      }
    },
    async getUploads() {
      this.uploadLoading = true;
      try {
        const data = await this.$aesEncrypt({
          page: this.uploadPage,
          pageSize: this.uploadPageSize,
          status: this.uploadStatus,
        });
        const res = await this.$axios({
          url: "aitool/list/status",
          method: "POST",
          data: { data },
        });
        if (res.code === 200) {
          this.uploadList = res.data.list || [];
          this.uploadTotal = res.data.total || 0;
        }
      } catch (error) {
        console.error("获取上传列表失败:", error);
      } finally {
        this.uploadLoading = false;
      }
    },
    async getUsers(key) {
      const data = await this.$aesEncrypt({
        page: this.userPage,
        pageSize: 50,
        searchKey: key,
      });
      try {
        const res = await this.$axios({
          url: "user/integral/rank",
          method: "POST",
          data: {
            data: data,
          },
        });
        if (res.code === 200) {
          console.log(res.data);
          this.userList = res.data.list || [];
          this.userTotal = res.data.total || 0;
        }
      } catch (error) {
        console.error("获取用户列表失败:", error);
      }
    },
    getCategory() {
      this.$axios({
        url: "category/list",
      }).then((res) => {
        if (res.code === 200) {
          this.categoryList = res.data;
        }
      });
    },
    // 上传管理操作
    changeUploadStatus(status) {
      this.uploadStatus = status;
      this.uploadPage = 1;
      this.getUploads();
    },
    handleUploadPageChange(page) {
      this.uploadPage = page;
      this.getUploads();
    },
    openToolDetail(tool) {
      globalState.openModal(tool.id, this.categoryList);
    },
    downloadAttachment(tool) {
      this.$axios({
        url: "aitool/exam/download/" + tool.id,
      })
        .then((res) => {
          if (res.code == 200) {
            const fileUrl = res.data.file;
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = tool.title;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            ElMessage.success("下载已开始");
          } else {
            ElMessage.error(res.msg || "下载失败");
          }
        })
        .catch(() => {
          ElMessage.error("网络错误，下载失败");
        });
    },
    async approveUpload(tool) {
      const isReApprove = tool.status === 2;
      const title = isReApprove ? "重新上架" : "通过审核";
      const confirmText = isReApprove
        ? `确定重新上架工具《${tool.title}》吗？`
        : `确定通过工具《${tool.title}》的审核吗？`;

      ElMessageBox.confirm(confirmText, title, {
        confirmButtonText: isReApprove ? "确定上架" : "确定通过",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(async () => {
          try {
            const data = await this.$aesEncrypt({
              id: tool.id,
              status: 1,
            });
            const res = await this.$axios({
              url: "aitool/exam",
              method: "PUT",
              data: { data },
            });
            if (res.code === 200) {
              ElMessage.success(isReApprove ? "工具已重新上架" : "审核已通过");
              this.getUploads();
              this.loadBadges();
            } else {
              ElMessage.error(res.msg || "操作失败");
            }
          } catch (error) {
            ElMessage.error("操作失败，请检查网络");
          }
        })
        .catch(() => {});
    },
    async rejectUpload(tool) {
      const isOffShelf = tool.status === 1;
      const title = isOffShelf ? "下架工具" : "拒绝审核";
      const promptText = isOffShelf ? "请输入下架理由" : "请输入拒绝理由";

      ElMessageBox.prompt(promptText, title, {
        confirmButtonText: isOffShelf ? "确定下架" : "确定拒绝",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "理由不能为空",
      })
        .then(async ({ value }) => {
          try {
            const data = await this.$aesEncrypt({
              id: tool.id,
              status: 2,
              examInfo: value,
            });
            const res = await this.$axios({
              url: "aitool/exam",
              method: "PUT",
              data: { data },
            });
            if (res.code === 200) {
              ElMessage.success(isOffShelf ? "工具已下架" : "已拒绝该申请");
              this.getUploads();
              this.loadBadges();
            } else {
              ElMessage.error(res.msg || "操作失败");
            }
          } catch (error) {
            ElMessage.error("操作失败，请检查网络");
          }
        })
        .catch(() => {});
    },
    deleteUpload(tool) {
      ElMessageBox.confirm(
        `确定删除工具"${tool.title}"吗？删除后不可恢复`,
        "删除工具",
        {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "error",
        },
      ).then(() => {
        this.$axios({
          url: `aitool/admin/${tool.id}`,
          method: "DELETE",
        }).then((res) => {
          if (res.code === 200) {
            ElMessage.success("删除成功");
            this.getUploads();
          } else {
            ElMessage.error(res.msg || "删除失败");
          }
        });
      });
    },
    // 创值榜操作
    handleUserPageChange(page) {
      this.userPage = page;
      this.getUsers("");
    },
    handleUserSearch(keyword) {
      // 可以实现服务器端搜索
      console.log("搜索用户:", keyword);
      this.getUsers(keyword);
    },
  },
};
</script>
